'use strict';

var dom        = require('spa-dom'),
    Scrollbar  = require('stb-component-scrollbar'),
    ScrollArea = require('mag-component-scroll-area'),

    infoPanel = {},

    tag = dom.tag,

    $lockContainer = tag('div', {className: 'info theme-icon theme-icon-lock'}),
    $poster = tag('div', {className: 'info poster'}),
    $rating = tag('div', {className: 'info actors'}),
    $director = tag('div', {className: 'info director'}),
    $actors = tag('div', {className: 'info actors'}),
    $infoContainer;


$infoContainer = tag(
    'div',
    {},
    $poster,
    tag('div', {className: 'info title theme-subhead-color'}, gettext('Rating:')),
    $rating,
    tag('div', {className: 'info title theme-subhead-color'}, gettext('Director:')),
    $director,
    tag('div', {className: 'info title theme-subhead-color'}, gettext('Actors:')),
    $actors
);

infoPanel.textArea = new ScrollArea({
    propagate: true,
    step: 5,
    scroll: new Scrollbar({})
});

infoPanel.textArea.$body.appendChild($infoContainer);
infoPanel.textArea.$body.appendChild($lockContainer);

infoPanel.clear = function () {
    $poster.style.backgroundImage = '';
    $infoContainer.style.display = 'none';
    $actors.innerText = '';
    $rating.innerText = '';
    $director.innerText = '';
    this.textArea.init();
};

infoPanel.showInfo = function () {
    $infoContainer.style.display = 'block';
    $lockContainer.style.display = 'none';
    this.textArea.init();
};

infoPanel.showLock = function () {
    $infoContainer.style.display = 'none';
    $lockContainer.style.display = 'block';
    this.textArea.init();
};

infoPanel.fill = function ( value ) {
    if ( value.cover ) {
        $poster.style.backgroundImage = 'url(' + core.backend.host + value.cover + ')';
    } else {
        $poster.style.backgroundImage = '';
    }
    $rating.innerText = value['rating_imdb'] || value['rating_kinopoisk'];

    $actors.innerText = value.actors;
    $director.innerText = value.director;
    infoPanel.textArea.init();
};


module.exports = infoPanel;
